// Anthropic token prices in USD per million tokens (verify at console.anthropic.com/settings/billing)
export const MODEL_PRICING = {
  'claude-haiku-4-5':  { input: 1.00, output: 5.00  },
  'claude-sonnet-4-6': { input: 3.00, output: 15.00 },
  'claude-opus-4-7':   { input: 5.00, output: 25.00 },
};

export const MODEL_META = {
  'claude-haiku-4-5': {
    label:       'Haiku 4.5',
    description: 'Snabb och billig. Bra för enkla uppgifter.',
    recommended: false,
    warning:     null,
  },
  'claude-sonnet-4-6': {
    label:       'Sonnet 4.6',
    description: 'Standardval. Bra balans mellan kvalitet och kostnad.',
    recommended: true,
    warning:     null,
  },
  'claude-opus-4-7': {
    label:       'Opus 4.7',
    description: 'Kraftfullast men dyrast. Använd bara när kvalitet är kritisk.',
    recommended: false,
    warning:     'Opus 4.7 använder en ny tokenizer som kan ge ~35% fler tokens för samma text. Förväntad kostnad är högre än andra modeller.',
  },
};

export const DEFAULT_MODEL = 'claude-sonnet-4-6';

export function calcCost(model, tokensIn, tokensOut) {
  const p = MODEL_PRICING[model] || MODEL_PRICING[DEFAULT_MODEL];
  return (tokensIn * p.input + tokensOut * p.output) / 1_000_000;
}
